import { filter } from 'rxjs/operators';
import { switchAll, toArray } from 'rxjs/operators';
import { DocumentShareService } from './../../../../shared/services/document/document-share/document-share.service';
import { unwrapConnection } from 'src/app/shared/rxjs.pipes';
import { IApiPhotoFolder, IApiPhotoFolderFilterType, IApiInvestigation, IApiDocument, IApiDocumentFilterType } from 'src/app/shared/modules/graphql/types/types';
import { DocumentService, PhotoFolderService } from 'src/app/shared/services';
import { LoaderService } from 'src/app/shared/modules/loader/loader.service';
import { Component, OnInit, Inject, Input } from '@angular/core';
import { DocumentCategories } from 'src/app/shared/modules/graphql/constants/document.constants';
import { DocumentStatus } from 'src/app/shared/modules/graphql/enums/document-snapshot.enums';
import {
  investigationPhotos,
  investigationPhotoShareCreate,
  investigationDocumentsListView,
  investigationDocumentShareCreate,
} from "src/app/shared/helpers/auth-config/investigations.config";
import { NotificationsService } from 'src/app/shared/modules/notifications/notifications.service';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { forkJoin } from 'rxjs';
import { IContactClientDetails } from 'src/app/components/shared/investigations/investigation-documents/markas-sent/markas-sent.component';
import { groupBy } from '@progress/kendo-data-query';

interface ISelectableFolder extends IApiPhotoFolder {
  downloadOption: DownloadOptions;
}

interface IData {
  investigation: IApiInvestigation;
}

// Interfaces to allow download options for each photo folder
enum DownloadOptions {
  all = 'all',
  used = 'used',
  unused = 'unused',
  none = 'none'
}

@Component({
  selector: 'app-investigation-download-share-files-modal',
  templateUrl: './investigation-download-share-files-modal.component.html',
  styleUrls: ['./investigation-download-share-files-modal.component.scss']
})
export class InvestigationDownloadShareFilesModalComponent extends DialogContentBase implements OnInit {
  public authConfig = {
    investigationPhotos,
    investigationPhotoShareCreate,
    investigationDocumentsListView,
    investigationDocumentShareCreate,
  };

  @Input() data: IData;

  public error: string = null;

  public photoFolders: ISelectableFolder[] = [];
  public documents: IApiDocument[] = [];
  public selectedDocuments: string[] = [];

  public get investigation(): IApiInvestigation {
    return this.data.investigation;
  }

  public groupedDataClientContactList: Array<IContactClientDetails> = [];
  private clientContactList = [];
  public selectedContact: Array<IContactClientDetails> = [];
  public selectedContactIds: Array<string> = [];
  public highRes = false;

  constructor(
    public loader: LoaderService,
    private photoFolderService: PhotoFolderService,
    private documentService: DocumentService,
    private documentShares: DocumentShareService,
    private notifications: NotificationsService,
    public dialogRef: DialogRef
  ) {
    super(dialogRef);
  }

  ngOnInit() {
    console.log(this.data);
    this.loader.show$(
      forkJoin([
        this.getDocuments(),
        this.getPhotoFolders(),
      ])
    ).subscribe(([documents, photoFolders]) => {
      this.documents = documents;
      this.photoFolders = photoFolders;
      this.photoFolders.map(a => a.downloadOption = DownloadOptions.none);
    });

    if (this?.data?.investigation?.BillTo) {
      const primary = this.data?.investigation?.BillTo?.Emails?.find(email => email.isPrimary === true)?.address || null;
      const email = this.data?.investigation?.BillTo?.Emails?.length ? (primary || this.data?.investigation?.BillTo?.Emails[0]?.address) : null;
      this.clientContactList.push({
        id: `billto_${this?.data?.investigation?.BillTo?.id}`,
        key: this?.data?.investigation?.BillTo?.id,
        text: `${this?.data?.investigation?.BillTo?.firstName} ${this?.data?.investigation?.BillTo?.lastName}`,
        companyName: `${this?.data?.investigation?.BillToBranch?.Company?.name}`,
        type: 'Bill To',
        email: email
      });
    }
    if (this?.data?.investigation?.Client) {
      const primary = this.data?.investigation?.Client?.Emails?.find(email => email.isPrimary === true)?.address || null;
      const email = this.data?.investigation?.Client?.Emails?.length ? (primary || this.data?.investigation?.Client?.Emails[0]?.address) : null;
      this.clientContactList.push({
        id: `client_${this?.data?.investigation?.Client?.id}`,
        text: `${this?.data?.investigation?.Client?.firstName} ${this?.data?.investigation?.Client?.lastName}`,
        companyName: `${this?.data?.investigation?.ClientBranch?.Company?.name}`,
        type: 'Client',
        key: this?.data?.investigation?.Client?.id,
        email: email
      });
    }
    if (this?.data?.investigation?.Parties?.length > 0) {
      this?.data?.investigation?.Parties.map(obj => {
        const primary = obj?.Contact?.Emails?.find(email => email.isPrimary === true)?.address || null;
        const email = obj?.Contact?.Emails?.length ? (primary || obj?.Contact?.Emails[0]?.address) : null;
        this.clientContactList.push({
          id: `additional_${obj?.Contact?.id}`,
          text: `${obj?.Contact?.firstName} ${obj?.Contact?.lastName}`,
          companyName: `${obj?.Contact?.Branches?.[0]?.Company?.name || ''}`,
          type: 'Additional Contacts',
          key: obj?.Contact?.id,
          email
        });
      });
    }

    this.groupedDataClientContactList = groupBy(this.clientContactList, [
      { field: "type" },
    ]);
  }

  public getDocuments() {
    return this.documentService.get([
      {
        type: IApiDocumentFilterType.Investigation,
        value: this.data.investigation.id
      }
    ]).pipe(
      unwrapConnection(),
      switchAll(),
      filter(({ Type: { Category }, Status }: IApiDocument) => (Category.name === DocumentCategories.UPLOAD) || (Category.name === DocumentCategories.REPORT && Status.status === DocumentStatus.FINAL)),
      toArray()
    );
  }

  public getPhotoFolders() {
    return this.photoFolderService.get([
      {
        type: IApiPhotoFolderFilterType.Investigation,
        value: this.data.investigation.id
      },
      {
        type: IApiPhotoFolderFilterType.ViewList,
        value: "true"
      }
    ], {}).pipe(
      unwrapConnection()
    );
  }

  public toggleDocument({ id }: IApiDocument) {
    const idx = this.selectedDocuments.indexOf(id);

    if (idx !== -1) {
      this.selectedDocuments.splice(idx, 1);
    }
    else {
      this.selectedDocuments.push(id);
    }
  }

  public toggleAllDocuments() {
    if (!this.documents.length) return;

    if (this.selectedDocuments.length === this.documents.length) {
      this.selectedDocuments = [];
    }
    else {
      this.selectedDocuments = this.documents.map(({ id }) => id);
    }
  }

  public toggleAllPhotos(event): void {
    event?.target?.checked ? this.photoFolders.map(a => a.downloadOption = DownloadOptions.all) : this.photoFolders.map(a => a.downloadOption = DownloadOptions.none);
  }

  public findSelectedPhotos() {
    const selectedPhotos = this.photoFolders.filter(p => p.downloadOption !== DownloadOptions.none);
    return selectedPhotos?.map(f => {
      let isUsed = null;
      switch (f.downloadOption) {
        case DownloadOptions.all:
          isUsed = null;
          break;
        case DownloadOptions.used:
          isUsed = true;
          break;
        case DownloadOptions.unused:
          isUsed = false
          break;
      }
      return {
        id: f.id,
        isUsed: isUsed
      }
    });
  }

  // Toggle "Select All" checkbox if all are selected
  public allPhotosSelected() {
    const download = this.photoFolders.filter(a => a.downloadOption === DownloadOptions.all).length;
    const all = this.photoFolders.length;
    return !!download && download === all;
  }

  // Check to see if selections are made. If so, share documents
  public share() {
    //
    if (!this.selectedContactIds?.length) {
      this.error = 'Please select a party to share documents with.';
      return;
    }

    if (this.findSelectedPhotos().length < 1 && this.selectedDocuments.length < 1) {
      this.error = 'No files are available to share with your selection.';
      return;
    }

    const selected = this.clientContactList?.filter(contact => this.selectedContactIds?.includes(contact.id));

    const billTo = selected?.find(contact => contact?.key === this.investigation?.BillTo?.id && contact.type === 'Bill To') || null;
    const client = selected?.find(contact => contact?.key === this.investigation?.Client?.id && contact.type === 'Client') || null;
    this.loader.show$(
      this.documentShares.add({
        InvestigationId: this.investigation.id,
        DocumentIds: this.selectedDocuments,
        Folders: this.findSelectedPhotos(),
        ClientId: client?.key,
        BillToId: billTo?.key,
        contacts: JSON.stringify(selected),
        highRes: this.highRes
      })
    ).subscribe(() => {
      this.notifications.kendoConfirm("Your request to share files has been successfully queued. You will receive a confirmation email when they are ready. You can also find them under Investigation Details > Documents > Shared Documents section once they are available.", "Share Files Request", "", "Ok").subscribe(() => {
        this.close(true);
      });
    });
  }

  public close(result = false) {
    this.dialogRef.close(result);
  }

  public tagMapper(tags: any[]): any[] {
    return tags.length < 3 ? tags : [tags];
  }

  public valueChange(event) {
    this.selectedContactIds = event?.map(obj => obj.id);
  }

}
